import { render } from "./CreateAssetInfo.vue?vue&type=template&id=bcde0f0e&scoped=true"
import script from "./CreateAssetInfo.vue?vue&type=script&lang=js"
export * from "./CreateAssetInfo.vue?vue&type=script&lang=js"

import "./CreateAssetInfo.vue?vue&type=style&index=0&id=bcde0f0e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcde0f0e"]])

export default __exports__